import { createFileRoute } from '@tanstack/react-router';
import { PurchasePage } from '@/features/pda/purchase/purchase-page';

export const Route = createFileRoute('/_app/purchase/')({ component: PurchasePage });
